import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import IconBase64 from '@deprecated-ui/common/IconBase64';
import InputAntd from '@deprecated-ui/common/Input';
import color from '@deprecated-ui/_style/color';
import device from '@deprecated-ui/_style/device';
import styled from 'styled-components';
import { pollingCloseIcon, removeIcon } from '../../../assets/base64icon';

const InputContainer = styled(Flex)`
  position: relative;
  align-items: center;
  width: calc(100% - 60px);

  .ant-input-affix-wrapper {
    border-radius: 3px;
  }
`;

const Input = styled(InputAntd)`
  input::placeholder {
    font-family: var(--font-bold);
    color: ${color.midgray} !important;
  }
`;

const IconAbsolute = styled(IconBase64).attrs({ iconSize: '16px' })`
  position: absolute;
  width: 16px;
  height: 16px;
  cursor: pointer;
`;

const IconRemove = styled(IconAbsolute).attrs({ icon: removeIcon })`
  right: -18px;
  top: 12px;
`;

const IconClose = styled(IconAbsolute).attrs({ icon: pollingCloseIcon })`
  top: 20px;
  right: 20px;
`;

// Polling checkbox

const CheckBoxContainer = styled(Flex)`
  align-items: center;
  cursor: pointer;
`;

// Polling date
const SelectDateWrapper = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  padding-bottom: 5px;
  width: 100%;
  label {
    font-size: 12px;
    padding-right: 6px;
  }
  select {
    padding: 0px 20px 0px 6px;
    height: 28px;
    border: 1px solid ${color.gainsboro};
    width: calc(100% - 50px);
  }
  label,
  select {
    color: ${
      // @ts-expect-error
      ({ disabled }) => (disabled ? color.midgray : color.highempahis)};
  }

  @media ${device.tablet} {
    justify-content: left;
  }
`;

// Pinned polling
const PinnedPollingLabelContainer = styled(Flex)`
  align-items: center;
  cursor: pointer;
`;

// Polling footer
const PollingFooterContainer = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  white-space: nowrap;
  padding-top: 15px;
  margin-top: 15px;
  border-top: 1px solid ${color.gainsboro};
`;

const ReverseFlex = styled(Flex)`
  position: relative;
  flex-direction: column;
  white-space: nowrap;
  width: 100%;

  @media ${device.tablet} {
    flex-direction: row;
  }
`;

const PollingTimeLabel = styled(Text)`
  font-size: 14px;
  line-height: 28px;
  color: ${color.midgray};
  & > span {
    font-size: 14px;
    color: ${color.primary};
    max-width: 100px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    vertical-align: middle;
    cursor: pointer;
  }
  @media ${device.tablet} {
    & > span {
      max-width: unset;
    }
  }
`;

const PollingTimeContent = styled.div`
  width: 100%;
  @media ${device.tablet} {
    padding-left: 12px;
    input,
    button {
      display: inline-block;
    }
  }
`;

const ButtonConfirm = styled(Button)`
  position: absolute;
  right: 0;
  bottom: -28px;
  height: 28px;
  padding: 0 10px;
  border: 1px solid ${color.gainsboro};
  background: ${color.whisper};
  color: ${color.highempahis};
  cursor: pointer;
  @media ${device.tablet} {
    position: relative;
    right: unset;
    bottom: unset;
  }
`;

const PollingContainer = styled.div`
  position: relative;
  border: 1px solid ${color.gainsboro};
  padding: 20px 20px 20px 30px;
  background: ${color.snow};
  margin-bottom: 20px;
  border-radius: 0 0 3px 3px;
`;

const PollingTextBox = styled.div`
  border: 1px solid ${color.gainsboro};
  border-bottom: none;
  padding: 20px 20px 20px 30px;
  border-radius: 3px 3px 0 0;
`;

export {
  InputContainer,
  IconAbsolute,
  IconRemove,
  IconClose,
  CheckBoxContainer,
  SelectDateWrapper,
  PinnedPollingLabelContainer,
  PollingFooterContainer,
  PollingTimeContent,
  ReverseFlex,
  PollingTimeLabel,
  ButtonConfirm,
  PollingContainer,
  PollingTextBox,
  Input,
};
